import React from 'react';
import { ReactDataTable } from '@metarouter-private/mr-mui';
import transformationLibTableColumns from './transformationLibTableColumns';
import TransformationLibNoData from './TransformationLibNoData';
import TransformationLibTableHeader from './TransformationLibTableHeader';
import { useTransformationLibTableContext } from 'app/clusters/TransformationLibTab/TransformationLibTable/TransformationLibTableContext';
import { useDrawerContext } from 'app/shared/contexts/drawer';
import { TRANSFORMATION_LIB_DRAWER } from './TransformationLibDrawer';
import { useTrackWithUser } from '@ion/api';

const PER_PAGE = 10;

function TransformationLibTable() {
  const { isLoading, transformLibModules } = useTransformationLibTableContext();
  const { launchDrawer } = useDrawerContext();
  const [transformationLibDrawerViewed] = useTrackWithUser('transformation_library_drawer_viewed');

  const handleRowClicked = row => {
    launchDrawer({
      drawer: TRANSFORMATION_LIB_DRAWER,
      transformModuleName: row.name,
      transformModuleBody: row.body,
    });
    transformationLibDrawerViewed();
  };

  return (
    <ReactDataTable
      title={<TransformationLibTableHeader />}
      columns={transformationLibTableColumns}
      loading={isLoading}
      paginationResetDefaultPage={isLoading}
      data={transformLibModules}
      noDataComponent={<TransformationLibNoData />}
      pagination
      paginationPerPage={PER_PAGE}
      highlightOnHover
      pointerOnHover
      keyField="name"
      onRowClicked={handleRowClicked}
    />
  );
}

export default TransformationLibTable;
